import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./Slider.css";

const API_BASE = "https://api.scoriva.net";

export default function Slider() {
  const { i18n } = useTranslation();

  const [slides, setSlides] = useState([]);
  const [active, setActive] = useState(0);
  const timerRef = useRef(null);

  const next = () => setActive((p) => (slides.length ? (p + 1) % slides.length : 0));
  const prev = () => setActive((p) => (slides.length ? (p - 1 + slides.length) % slides.length : 0));

  // ✅ camelCase/pascalCase hər ikisini də dəstəkləyir
  const pickLang = (x, base) => {
    const lang = (i18n?.language || "az").toLowerCase();
    const suffix = lang.startsWith("en") ? "En" : lang.startsWith("ru") ? "Ru" : "Az";

    // backend JSON: titleAz / descAz
    const baseCamel = base.charAt(0).toLowerCase() + base.slice(1); // "title" / "desc"
    const keyCamel = `${baseCamel}${suffix}`; // "titleAz"
    const keyPascal = `${base}${suffix}`;     // "TitleAz" (əgər serializer dəyişsə)

    return x?.[keyCamel] ?? x?.[keyPascal] ?? x?.[baseCamel] ?? x?.[base] ?? "";
  };

  useEffect(() => {
    let isMounted = true;

    async function load() {
      try {
        const res = await axios.get(`${API_BASE}/api/Sliders`);
        if (!isMounted) return;

        const data = (res.data || []).map((x) => ({
          id: x.id,
          // ✅ indi doğrudan titleAz/titleEn/titleRu seçəcək
          title: pickLang(x, "Title"),
          desc: pickLang(x, "Desc"),
          image: `${API_BASE}/api/Sliders/${x.id}/image`,
        }));

        setSlides(data);
        setActive(0);
      } catch (err) {
        console.error("Slider load error:", err);
        setSlides([]);
      }
    }

    load();
    return () => { isMounted = false; };
    // ✅ dil dəyişəndə yenidən map etsin deyə
  }, [i18n.language]);

  useEffect(() => {
    if (!slides.length) return;

    timerRef.current = setInterval(next, 4500);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides.length]);

  const onMouseEnter = () => clearInterval(timerRef.current);
  const onMouseLeave = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(next, 4500);
  };

  if (!slides.length) return null;

  return (
    <section id="home" className="hero" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className="heroInner">
        <div className="slides">
          {slides.map((s, i) => (
            <article
              key={s.id ?? i}
              className={`slide ${i === active ? "active" : ""}`}
              style={{ backgroundImage: `url(${s.image})` }}
              aria-hidden={i === active ? "false" : "true"}
            >
              <div className="slideOverlay" />
              <div className="slideContent">
                <h1 style={{width:"72%"}}>{s.title}</h1>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="controls">
          <button className="iconBtn" onClick={prev} aria-label="Prev">‹</button>

          <div className="dots" role="tablist" aria-label="Slides">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === active ? "on" : ""}`}
                onClick={() => setActive(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>

          <button className="iconBtn" onClick={next} aria-label="Next">›</button>
        </div>
      </div>
    </section>
  );
}
